import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import apiStore from "../../../../../../../utils/apiStore";
import MyIcons from "../../../../../../golbal/icons/myIcons";
import ToastNote from "../../../../../../golbal/notifications/toastNote";
import renderData from "../../../../../../../utils/renderData";
import SearchBarUser from "./searchBarUser";
import ColoredSpinner from "../../../../../../alret/spiners/coloredSpiner/coloredSpinner";
import tools from "../../../../../../../utils/tools";
import { CartContext } from "../../../../../../contexts/cartContext";
import MetaDecorator from "../../../../../../../utils/metaDecorator";

export default function RefCodeList({ access, section }) {
  const { user } = useContext(CartContext);
  const [countryShort, stateShort] = window.location.pathname
    .toLowerCase()
    .split("/")
    .slice(2, 4);

  const navigate = useNavigate();
  const messageRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [user2, setUser2] = useState({ _id: user._id });

  const deleteHandle = async (id) => {
    console.log(id);
    if (!id)
      return messageRef.current.showError({ message: "No Id Provided." });
    if (window.confirm("Are you sure to delete this transaction") !== true) return;
    const response = await apiStore.deleteRow({
      token: user.token,
      id,
      userId: user._id,
    });
    if (response.error)
      return messageRef.current.showError({ message: response.error });
    messageRef.current.showSuccess({ message: "Successful delete action." });
    setData((pre) => {
      return pre.filter((row) => row._id !== id);
    });
  };
  function showPageHandle({ props }) {
    let text = "";
    // if (window.lang !== props.lang.toLowerCase())
    //   text += `شما در حال انتقال به متامارس با زبان ${window.capitalize(
    //     props.lang
    //   )} میباشد . \n`;
    // if (countryShort.toLowerCase() !== props.address.countryShort.toLowerCase())
    //   text += `شما در حال انتقال به کشور ${window.capitalize(
    //     props.address.country
    //   )} میباشد . \n`;
    // if (stateShort.toLowerCase() !== props.address.stateShort.toLowerCase())
    //   text += `شما در حال انتقال به استان ${window.capitalize(
    //     props.address.state
    //   )} میباشد . \n`;

    if (!text.length)
      return navigate(`/${window.lang}/store/order/${props._id}`);

    if (window.confirm(text) != true) return;
    console.log("Passed");

    navigate(`/${window.lang}/store/order/${props._id}`);
  }

  useEffect(() => {
    fetchData();
  }, [user2._id, window.location.pathname]);
  async function fetchData() {
    setLoading(true);
    const response = await apiStore.fetchRefcodeTrans({
      token: user.token,
      id: user2._id,
      access,
      section,
    });
    setLoading(false);
    console.log(response);
    if (response.error) return alert(response.error);

    setData(response.data);
  }

  function showPrice(amount, currency) {
    const cur = currency || "USD";
    const final = (amount || 0).toLocaleString(window.lang, {
      style: "currency",
      currency: cur,
      minimumFractionDigits: cur === "IRR" ? 0 : 2,
      maximumFractionDigits: cur === "IRR" ? 0 : 2,
    });
    return final;
  }

  const trans = {   
    date:{en:'Date',fa: "تاریخ ثبت"},
    paid:{en:'Paid',fa:"تکمیل سفارش"},
    refCode:{en:'Refferal Code',fa:"کد معرفی"},
    MaMargin:{en:'Marketing Margin',fa:"مارجین بازاریابی"},
    userDisc:{en:'User Discount',fa:"تخفیف کاربر"},
    isPaid:{en:'Is Paid',fa:"تکمیل سفارش"},
    netSales:{en:'Net Sales',fa:"فروش پس از تخفیفات"},
    maMargin2:{en:'marketerMargin',fa:"کارمزد بازاریابی"},
    country:{en:'Country',fa:"کشور"},
    serviceItems:{en:'serviceItems',fa: "نام امکانات"},
    invNumber:{en:'Inv Number',fa:"شماره صورتحساب"},
    action:{en:'Action',fa:"عملیات"},
    goMaPro:{en:'Marketer page',fa:"صفحه بازاریاب"},
    affReport:{en:'Affiliation Report',fa:"گزارش عملکرد بازاریابی"},
    descHead:{en:'View affiliation Report',fa:"مشاهده گزارش عملکرد بازاریابان متامارس "},
    noData:{en:'No data is available.',fa:"داده ای پیدا نشد. پس از اطمینان از وجود داده، دوباره تلاش کنید."},
     }

  const columns = [
    //   { field: '_id', headerName: 'ID', width: 70 },

    {
      field: "createdAt",
      headerName:trans.date[window.lang],
      width: 100,
      renderCell: (params) => (
        <div title={tools.toSolar(params.row?.updatedAt)}>
          {tools.toGreg(params.row?.updatedAt)}
        </div>
      ),
    },
    {
      field: "marketerInfo.refCode",
      headerName: trans.refCode[window.lang],
      width: 110,
      renderCell: (params) => (
        <strong>{params.row.marketerInfo.refCode}</strong>
      ),
    },
    {
      field: "marketerInfo.refPercent",
      headerName: trans.MaMargin[window.lang],
      width: 110,
      renderCell: (params) => (
        <strong title="">{`% ${
          params.row.marketerInfo.refPercent * 100
        }`}</strong>
      ),
    },
    {
      field: "marketerInfo.discPercent",
      headerName: trans.userDisc[window.lang],
      width: 110,
      renderCell: (params) => (
        <strong title="">{`% ${
          params.row.marketerInfo.discPercent * 100
        }`}</strong>
      ),
    },
    {
      field: "isPaid",
      headerName: trans.isPaid[window.lang],
      width: 100,
      renderCell: (params) => <div>{params.row.isPaid ? "Yes" : "No"}</div>,
    },
    // {
    //   field: "totalPrice1",
    //   headerName: "مبلغ پرداختی",
    //   width: 100,
    //   renderCell: (params) => <div>{showPrice(
    //     Number(params.row?.paymentResult[0]?.amount?.value),
    //     params.row?.paymentResult?.[0]?.amount?.currency_code
    //   )}</div>,
    // },
    {
      field: "netSales",
      headerName: trans.netSales[window.lang],
      width: 100,
      renderCell: (params) => (
        <div>
          {showPrice(
            Number(params.row?.paymentResult?.[0]?.amount?.value) > 0
              ? params.row.itemsPrice - params.row.discAmount
              : 0,
            params?.row?.currency
          )}
        </div>
      ),
    },
    {
      field: "marketerMargin",
      headerName:trans.maMargin2[window.lang],
      width: 100,
      renderCell: (params) => (
        <div>
          {showPrice(
            Number(params.row?.paymentResult?.[0]?.amount?.value) > 0
              ? (params.row.itemsPrice - params.row.discAmount) *
                  params.row.marketerInfo.discPercent
              : 0,
            params?.row?.currency
          )}
        </div>
      ),
    },
    {
      field: "address.country",
      headerName: trans.country[window.lang],
      width: 150,
      renderCell: (params) => (
        <div dir="ltr">{`${window.capitalize(
          params.row?.address?.state
        )}, ${window.capitalize(params.row?.address?.country)}`}</div>
      ),
    },
    {
      field: "serviceItems",
      headerName: trans.serviceItems[window.lang],
      width: 200,
      renderCell: (params) => {
        return params.row.serviceItems.map((serv, i) => (
          <span key={i}>
            <span title={serv.title}>
              {
                renderData.plansName.find((plan) => plan.name === serv?.type)?.[
                  window.lang
                ]
              }
            </span>
            -
          </span>
        ));
      },
    },
    // {
    //   field: "totalPrice",
    //   headerName: "مبلغ صورتحساب",
    //   width: 150,
    //   renderCell: (params) => (
    //     <div
    //       title={`مبلغ پرداختی  ${showPrice(
    //         Number(params.row?.paymentResult[0]?.amount?.value),
    //         params.row?.paymentResult[0]?.amount?.currency_code
    //       )}`}
    //     >
    //       {showPrice(params.row?.totalPrice, params.row?.currency)}
    //     </div>
    //   ),
    // },
    access === "admin" && {
      field: "invNumber",
      headerName: trans.invNumber[window.lang],
      width: 150,
      // renderCell:params=>  <div title={params.row?.paymentResult[0]?.amount?.value}>{params.row?.paymentResult[0]?.amount?.currency_code+params.row?.paymentResult[0]?.amount?.value}</div>
    },
    access === "admin" && {
      field: "action",
      headerName: trans.action[window.lang],
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            <div
              title="View"
              className="widgetSmButton"
              onClick={(e) => showPageHandle({ props: params.row })}
            >
              <MyIcons icon="display" />
            </div>
            {!params.row.isPaid && (
              <div
                title="Delete"
                onClick={() => deleteHandle(params.row._id)}
              >
                <MyIcons icon="delete2" />
              </div>
            )}
          </div>
        );
      },
    },
  ];
  // console.log('data',data);
  const metaTagsData = {
    title: trans.affReport[window.lang],
    description: trans.descHead[window.lang],
    section: "refCode list",
    url: `https://www.metamarce.com/${window.lang}/dashboard/user/trans/points`,
    canonical: `https://www.metamarce.com/${window.lang}/dashboard/user/trans/points`,
    img: "https://www.metamarce.com/img/illustration/buy-photography-gear-online.svg",
    type: "webpage",
    index: false,
  };
  return (
    <div className="userList" style={{ height: "80vh", width: "100%" }}>
      <MetaDecorator data={{ ...metaTagsData }} />
      <ToastNote messageRef={messageRef} />
      {loading && <ColoredSpinner />}
      {!data.length ? (
        <div>
          <div>
          {trans.noData?.[window.lang]}
          </div>
          <Link
            to={`/${window.lang}/dashboard/user/profile/marketer`}
            className="btn btn-primary share-cover-btn mx-2"
          >
           {trans?.goMaPro?.[window.lang]}
          </Link>
        </div>
      ) : (
        <DataGrid
          getRowId={(row) => row._id}
          rows={data}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          columns={columns}
          pageSize={[15]}
          rowsPerPageOptions={[1]}
          checkboxSelection
        />
      )}
      {access === "admin" && (
        <SearchBarUser setUser2={setUser2} user2={user2} />
      )}
    </div>
  );
}
